import { createSlice } from '@reduxjs/toolkit';
import Cookies from 'universal-cookie';
const cookie = new Cookies()
const userRoles = cookie.get('roles')
const userPermissions = cookie.get('permissions')
const loggedUser = localStorage.getItem('user');
const pageData = localStorage.getItem('data');
const userInfo = loggedUser ? JSON.parse(loggedUser) : null
const userData = pageData ? JSON.parse(pageData) : null
const userStates = cookie.get('userStates');

const setLocalData = (key, value) => {
    cookie.set(key, value)
    localStorage.setItem(key, JSON.stringify(value))
}

const clearLocalData = () => {
    cookie.remove('user')
    cookie.remove('roles')
    cookie.remove('permissions')
    cookie.remove('show_roles')
    cookie.remove('userStates')
    localStorage.clear()
}

export const userSlice = createSlice({
    name: 'user',
    initialState: {
        user: userInfo,
        roles: userRoles,
        permissions: userPermissions,
        data: userData,
        isPoStatus: false,
        userStates: userStates
    },
    reducers: {
        login: (state, action) => {
            state.user = action.payload.user
            localStorage.setItem('token', action.payload.token)
            setLocalData('user', action.payload.user)
            cookie.set('user', action.payload.user);
            setLocalData('show_roles', action?.payload?.user?.show_roles)
        },
        logout: (state) => {
            state.user = null
            state.roles = null
            state.permissions = null
            clearLocalData()
        },
        setRoles: (state, param) => {
            state.roles = param.payload
            setLocalData('roles', param.payload)
        },
        setPermissions: (state, param) => {
            state.permissions = param.payload
            setLocalData('permissions', param.payload)
        },
        erasePermissions: (state) => {
            state.permissions = null
            cookie.remove('permissions')
            localStorage.removeItem('permissions')
        },
        eraseRoles: (state) => {
            state.roles = null
            cookie.remove('roles')
            localStorage.removeItem('roles')
        },
        setData: (state, action) => {
            state.data = action.payload
            setLocalData('data', action.payload)
        },
        clearData: (state) => {
            state.data = null
            localStorage.removeItem('data');
        },
        setTravelTab: (state, action) => {
            state.travelTab = action.payload;
        },
        setIsPoStatus: (state, action) => {
            state.isPoStatus = action.payload;
        },
        setUserStates: (state, action) => {
            state.userStates = action.payload;
        }

    }
})
// User
export const { login, logout, setRoles, setPermissions, eraseRoles, setData, clearData, setIsPoStatus, setTravelTab, setUserStates } = userSlice.actions
export const selectUserStates = (state) => state.user.userStates
export const selectUser = (state) => state.user.user
// Roles
export const selectRoles = (state) => state.user.roles
// Permissions
export const selectPermissions = (state) => state.user.permissions
// Data
export const selectData = (state) => state.user.data
export const travelTabs = (state) => state.user.travelTab
//isPONumberStatus
export const projectPoNumber = (state) => state.user.isPoStatus
// Common
export default userSlice.reducer